module.exports = __webpack_public_path__ + "img/cend0.ab64cd5.png";